import React, { Component } from 'react';
import { Form, Button, Alert } from 'antd';
import { Field, reduxForm } from 'redux-form';
import { renderInput } from '../../shared/utils/form_components';
import { required, email } from '../../shared/utils/form_validations';

class LoginForm extends Component {
  render() {
    const { handleSubmit, error, submitting } = this.props;

    return (
      <Form layout="horizontal" className="login-form">
        {error && <Form.Item><Alert message={error} type="error" /></Form.Item>}

        <Field
          name="email"
          label="Email"
          component={renderInput}
          placeholder="Email"
          required
          validate={[required, email]}
        />

        <Field
          name="password"
          label="Password"
          component={renderInput}
          placeholder="Password"
          type="password"
          required
          validate={required}
        />

        <Button
          disabled={submitting}
          loading={submitting}
          type="primary"
          htmlType="button"
          className="login-form-button"
          onClick={() => handleSubmit()}
        >
          {submitting ? "Logging in..." : "Log in"}
        </Button>
      </Form>
    )
  }
}

export default reduxForm({ form: 'LoginForm' })(LoginForm);
